import React, { useContext, useCallback, useState } from "react";
import { Tabs, Card } from "@shopify/polaris";
import { ProductProvider } from "app/product/modules/generic/context";

// import context
import { PrivateContext } from "lib/context/privateContext";

// import Hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import prop
import { tabProp } from "app/product/modules/generic/propTypes";
import constant from "lib/constant/constant";
import addData, { getServicePanelComponent } from "app/product/modules/provider/features/add/config/addData";

const ServiceTabs = (props) => {
  const { setBanner } = props;
  const { cms } = useContext(PrivateContext);
  const [selected, setSelected] = useState(0);

  const handleTabChange = useCallback((selectedTabIndex) => setSelected(selectedTabIndex), []);
  return (
    <>
      <Card>
        <Tabs tabs={addData(cms).serviceTabs} selected={selected} setBanner={setBanner} />
      </Card>
      <ProductProvider
        value={{
          setBanner,
          handleTabChange,
        }}
      >
        <div className="productComponent">{getServicePanelComponent({ selectedTab: selected, cms })}</div>
      </ProductProvider>
    </>
  );
};

ServiceTabs.propTypes = tabProp.type;

export default withFeature(withErrorBoundary(ServiceTabs), { feature: constant.PRODUCT_ADD_FORM });
